// Componente ColorPicker - Selector de color con paleta
// Permite seleccionar colores para productos

import { useState } from 'react'
import { SketchPicker } from 'react-color'
import './ColorPicker.css'

/**
 * Componente ColorPicker
 * Selector de color con paleta predefinida y selector personalizado
 * @param {Object} props - Propiedades del componente
 * @param {string} props.value - Color seleccionado (hex)
 * @param {Function} props.onChange - Función a ejecutar al cambiar el color
 * @param {string} props.label - Etiqueta del campo
 */
function ColorPicker({ value = '#000000', onChange, label = 'Color' }) {
  const [showPicker, setShowPicker] = useState(false)

  // Paleta de colores predefinida para muebles
  const colorPalette = [
    '#2c3e50', // Gris oscuro
    '#34495e', // Gris medio
    '#7f8c8d', // Gris claro
    '#d4a574', // Beige/Dorado
    '#c9a882', // Beige claro
    '#a67c52', // Marrón medio
    '#8b6f47', // Marrón oscuro
    '#f5f5dc', // Beige muy claro
    '#deb887', // Burlywood
    '#d2691e', // Chocolate
    '#8b4513', // Saddle brown
    '#654321', // Marrón muy oscuro
    '#ffffff', // Blanco
    '#000000', // Negro
    '#f0e68c', // Khaki
    '#daa520'  // Goldenrod
  ]

  const handleColorChange = (color) => {
    onChange(color.hex)
  }

  const handlePaletteClick = (color) => {
    onChange(color)
    setShowPicker(false)
  }

  return (
    <div className="color-picker-container">
      <label className="color-picker-label">{label}</label>
      
      {/* Color seleccionado y botón para abrir picker */}
      <div className="color-picker-display">
        <div 
          className="color-preview"
          style={{ backgroundColor: value }}
          onClick={() => setShowPicker(!showPicker)}
        />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="color-input"
          placeholder="#000000"
        />
        <button
          type="button"
          onClick={() => setShowPicker(!showPicker)}
          className="picker-toggle-btn"
        >
          {showPicker ? '▼' : '▲'}
        </button>
      </div>

      {/* Paleta de colores predefinida */}
      <div className="color-palette">
        {colorPalette.map((color, index) => (
          <button
            key={index}
            type="button"
            className={`palette-color ${value === color ? 'selected' : ''}`}
            style={{ backgroundColor: color }}
            onClick={() => handlePaletteClick(color)}
            title={color}
          />
        ))}
      </div>

      {/* Picker avanzado */}
      {showPicker && (
        <div className="color-picker-popup">
          <div className="picker-overlay" onClick={() => setShowPicker(false)} />
          <div className="picker-content">
            <SketchPicker
              color={value}
              onChange={handleColorChange}
              disableAlpha
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default ColorPicker

